import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WHS_DISCREPANCIES_REQUEST = 'GET_WHS_DISCREPANCIES_REQUEST';
export const GET_WHS_DISCREPANCIES_SUCCESS = 'GET_WHS_DISCREPANCIES_SUCCESS';
export const GET_WHS_DISCREPANCIES_FAILURE = 'GET_WHS_DISCREPANCIES_FAILURE';

function requestGetWhsDiscrepancies() {
  return {
    type: GET_WHS_DISCREPANCIES_REQUEST,
    isGettingWhsDiscrepancies: true
  };
}

function receiveGetWhsDiscrepancies(formId, whsFormDiscrepancies) {
  return {
    type: GET_WHS_DISCREPANCIES_SUCCESS,
    isGettingWhsDiscrepancies: false,
    whsFormDiscrepancies
  };
}

function rejectGetWhsDiscrepancies() {
  return {
    type: GET_WHS_DISCREPANCIES_FAILURE,
    isGettingWhsDiscrepancies: false
  };
}

export function getWhsDiscrepancies(formId) {
  return (dispatch) => {
    dispatch(requestGetWhsDiscrepancies());

    return ApiService
      .getWhsDiscrepancies(formId)
      .then((response) => {
        dispatch(receiveGetWhsDiscrepancies(formId, response.data));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(
            handleException(error, rejectGetWhsDiscrepancies, !status || (status !== 404 && status !== 401))
          );
        }
      });
  };
}
